import React, { useState, useEffect, Fragment } from "react";
import CompanyBranchDropDown from "../../crm/CompanyBranchDropDown";

export default function CompanyBranchFilter({ company_id, company_branch_id, onChange, title }) {
  return (
    <Fragment>
      <label>{title || I18n.t("select_branch")}</label>
      <CompanyBranchDropDown
        company_id={company_id}
        onBranchChange={onChange}
        value={company_branch_id}
        includeBlank={true}
        blankLabel={"All Branches"}
      />
    </Fragment>
  );
}
